import { renderToStaticMarkup } from 'react-dom/server'
import { type ResourceModel, type TemplateColumnConfig } from '@bryntum/schedulerpro'
import { selectUserConfiguration } from '@/features/domain/user'
import { store } from '@/store'
import { intl } from '@/intl'

import { OrdersToDoCell } from '../../../components/cells/OrdersToDoCell'
import { ordersToDoSorter } from '../sorters/ordersToDoSorter'

export function createOrdersToDoColumn(
  width: string | number,
  hidden: boolean,
): Partial<TemplateColumnConfig> {
  return {
    text: intl.translate({ id: 'rm.scheduler.column.ordersToDo' }),
    type: 'template',
    field: 'ordersToDo',
    width,
    editor: false,
    hidden,
    region: 'cols',

    template: ({ record, field, value }) => {
      const state = store.getState()
      const { language } = selectUserConfiguration(state)

      return renderToStaticMarkup(
        <OrdersToDoCell
          record={record as ResourceModel}
          field={field}
          value={value}
          language={language}
        />,
      )
    },

    sortable: ordersToDoSorter,
    resizable: true,
    groupable: false,
  }
}
